/**
 * Copy for the public brand page (/brand/:authId).
 *
 * The certification line is built here from the cert type's scope and
 * coverage, because UGC_CERT_TYPE carries English labels only. Unknown scopes
 * fall back to that English label rather than guessing a translation.
 */
const translations = {
  hu: {
    langCurrent: "HU",
    langOther: "EN",
    dateLocale: "hu-HU",
    loading: "Márkaadatok betöltése…",
    errorTitle: "A márkaadatok most nem érhetők el",
    errorBody:
      "Kérjük, próbálja meg később. Ha a probléma tartósan fennáll, írjon nekünk:",
    notFoundTitle: "Ezt a márkát nem találjuk",
    notFoundBody:
      "Ehhez a címhez nem tartozik márka a nyilvántartásunkban. Lehet, hogy elgépelés, vagy a bejegyzést eltávolították.",
    searchAction: "Keresés a nyilvános listában",
    contactEmail: "info@ultragreencert.com",

    eyebrow: "MÁRKA A NYILVÁNTARTÁSBAN",
    website: "WEBOLDAL",
    certLabel: "TANÚSÍTÁS",
    certSince: (date) => `${date} óta`,
    certUntil: (date) => `${date}-ig érvényes`,
    certEnded: (date) => `${date} óta`,
    scope: {
      COSMETIC: "Auditált kozmetikai márka",
      DETERGENT: "Auditált tisztítószer-márka",
      BOTH: "Auditált kozmetikai és tisztítószer-márka",
    },
    andManufacturer: " és gyártó",
    status: {
      EXPIRED: "A tanúsítás lejárt",
      WITHDRAWN: "A tanúsítást szabályszegés miatt visszavonták",
    },

    productsTitle: "Tanúsított termékek",
    productsCount: (n) => `${n} termék`,
    productsEmpty:
      "Ennek a márkának jelenleg nincs érvényes tanúsítással rendelkező terméke a nyilvántartásban.",
    productValid: "ÉRVÉNYES",
    productValidSuffix: "-ig",

    footerCompany:
      "UltraGreen Kft. · 1039 Budapest, Batthyány utca 35/B. · Cg. 01-09-376313",
  },
  en: {
    langCurrent: "EN",
    langOther: "HU",
    dateLocale: "en-GB",
    loading: "Loading brand details…",
    errorTitle: "Brand details are not available right now",
    errorBody: "Please try again later. If the problem persists, write to us:",
    notFoundTitle: "We cannot find this brand",
    notFoundBody:
      "No brand in our register belongs to this address. It may be a typo, or the entry may have been removed.",
    searchAction: "Search the public register",
    contactEmail: "info@ultragreencert.com",

    eyebrow: "BRAND IN THE REGISTER",
    website: "WEBSITE",
    certLabel: "CERTIFICATION",
    certSince: (date) => `since ${date}`,
    certUntil: (date) => `valid until ${date}`,
    certEnded: (date) => `from ${date}`,
    // English uses the register's own label verbatim.
    scope: null,
    andManufacturer: "",
    status: null,

    productsTitle: "Certified products",
    productsCount: (n) => `${n} ${n === 1 ? "product" : "products"}`,
    productsEmpty:
      "This brand currently has no product with a valid certification in the register.",
    productValid: "VALID UNTIL",
    productValidSuffix: "",

    footerCompany:
      "UltraGreen Kft. · 1039 Budapest, Batthyány utca 35/B. · Cg. 01-09-376313",
  },
};

export default translations;
